export default __webpack_public_path__ + "static/media/bullet.dc371376.svg";